'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-f8b34207.js');

function isIE() {
    return (navigator.userAgent.indexOf('MSIE') > -1 ||
        navigator.userAgent.indexOf('Trident') > -1);
}
var IEConsole = {
    debug: function (args) {
        console.debug(args);
    },
    trace: function (args) {
        console.trace(args);
    },
    log: function (args) {
        console.log(args);
    },
    info: function (args) {
        console.log(args);
    },
    warn: function (args) {
        console.warn(args);
    },
    error: function (args) {
        console.error(args);
    },
    time: function (args) {
        console.time(args);
    },
    timeEnd: function (args) {
        console.timeEnd(args);
    },
    timeStamp: function (args) {
        console.timeStamp(args);
    },
    count: function (args) {
        console.count(args);
    },
    countReset: function (args) {
        console.countReset(args);
    },
    dir: function (args) {
        console.dir(args);
    },
    dirxml: function (args) {
        console.dirxml(args);
    },
    clear: function () {
        console.clear();
    }
};
function getHashFromString(str) {
    if (str === void 0) { str = ''; }
    if (!str) {
        return 0;
    }
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
}
// https://trendct.org/2016/01/22/how-to-choose-a-label-color-to-contrast-with-background/
function getTextColor(_a) {
    var _b = _a.light, light = _b === void 0 ? '#ffffff' : _b, _c = _a.dark, dark = _c === void 0 ? '#000000' : _c, _d = _a.red, red = _d === void 0 ? 0 : _d, _e = _a.green, green = _e === void 0 ? 0 : _e, _f = _a.blue, blue = _f === void 0 ? 0 : _f, _g = _a.threshold, threshold = _g === void 0 ? 128 : _g;
    // let threshold = 123;
    var cBrightness = (red * 299 + green * 587 + blue * 114) / 1000;
    return cBrightness > threshold ? dark : light;
}
function generateColorFromString(str, alpha) {
    if (alpha === void 0) { alpha = 1; }
    if (!str) {
        return str;
    }
    var hash = getHashFromString(str);
    var red = (hash >> (0 * 8)) & 0xff;
    var green = (hash >> (1 * 8)) & 0xff;
    var blue = (hash >> (2 * 8)) & 0xff;
    var norm = function (str) { return str.length < 2 ? "0".concat(str) : str; };
    return {
        red: red,
        green: green,
        blue: blue,
        hex: "#".concat(norm(red.toString(16))).concat(norm(green.toString(16))).concat(norm(blue.toString(16))),
        rgb: "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")"),
        rgba: "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(alpha, ")")
    };
}
/**
 * Get style according name.
 * Style have background color in RGB format and text color `white` or `black`
 * @param {string} name Name to get colors
 * @returns {String}  The style for `name` in format `{background: <color>, color: <color>}`
 */
function getStyle(name) {
    var _a = generateColorFromString(name), red = _a.red, green = _a.green, blue = _a.blue, rgb = _a.rgb;
    var textColor = getTextColor({
        red: red,
        green: green,
        blue: blue,
        light: '#ffffff',
        dark: '#000000'
    });
    return "\n    background: ".concat(rgb, ";\n    color: ").concat(textColor, ";\n  ");
}
function formatByDelimiters(outputPrefix, delimiter) {
    var left = delimiter[0];
    var right = delimiter[1];
    if (!Array.isArray(outputPrefix)) {
        if (left && right) {
            return "".concat(left).concat(outputPrefix).concat(right);
        }
        else if (!Array.isArray(delimiter)) {
            return "".concat(delimiter).concat(outputPrefix);
        }
        return "".concat(outputPrefix);
    }
    return outputPrefix.map(function (el) {
        if (left && right) {
            return "".concat(left).concat(el).concat(right);
        }
        else if (!Array.isArray(delimiter)) {
            return "".concat(delimiter).concat(el);
        }
        else {
            return "".concat(el);
        }
    });
}
// todo: add custom color supports
function formatConsoleOutput(outputPrefix, deep) {
    if (deep === void 0) { deep = 1; }
    var base = '%c%s%c';
    var baseShort = '%s';
    var elements = [];
    var styles = '';
    // const maxStyledItemsCount = config.style.maxStyledItem
    // if (config.project.name) {
    //   maxStyledItemsCount = maxStyledItemsCount - 1
    //   str = base
    //   elements = [
    //     config.project.style,
    //     formatDelimiters(config.project.name),
    //     config.clear
    //   ]
    //   if (isIE()) {
    //     str = baseShort
    //     elements = [formatDelimiters(config.project.name)]
    //   }
    // }
    outputPrefix.forEach(function (el, index) {
        if (index < deep && !isIE()) {
            styles += base;
            var style = getStyle(el);
            elements.push(style);
            elements.push(el);
            elements.push('background: transparent; color: inherit;');
        }
        else {
            styles += baseShort;
            elements.push(el);
        }
    });
    return tslib_es6.__spreadArray([styles], elements, true);
}

exports.IEConsole = IEConsole;
exports.formatByDelimiters = formatByDelimiters;
exports.formatConsoleOutput = formatConsoleOutput;
exports.generateColorFromString = generateColorFromString;
exports.getHashFromString = getHashFromString;
exports.getTextColor = getTextColor;
exports.isIE = isIE;
